import React from "react"
import { Grid, Typography } from "@material-ui/core"
import Image from "./image"

interface Props {
  title: string
  intro: string
  category: string
  image: string
  imageAlt: string
}

const ArticleHero = ({ title, intro, category, image, imageAlt }: Props) => (
  <Grid
    container
    spacing={4}
    alignItems="center"
    style={{ marginTop: 8, marginBottom: 24 }}
  >
    <Grid item xs={12} md={7}>
      <Typography variant="overline" component="p" color="primary">
        {category}
      </Typography>
      <Typography variant="h3" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" paragraph>
        {intro}
      </Typography>
    </Grid>
    <Grid item xs={12} md={5}>
      <Image filename={image} alt={imageAlt} />
    </Grid>
  </Grid>
)

export default ArticleHero
